import React from 'react';
import PropTypes from 'prop-types';

import './AudioPlayer.scss';

const AudioPlayer = ({ audioSrc }) => {
    return (
        <div className="component-Community-AudioPlayer">
            {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
            <audio width="100%" id="t-rex-roar" controls>
                <source type="audio/mpeg" src={audioSrc} />
                Your browser does not support the <code>audio</code> element.
            </audio>
        </div>
    );
};

AudioPlayer.propTypes = {
    audioSrc: PropTypes.string.isRequired,
};

AudioPlayer.displayName = 'AudioPlayer';

export default AudioPlayer;
